import { Typography } from '@euler/app/components/typography';
import { ApdmImportSummary } from '@euler/functions/apdm/import/importState';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { View } from 'react-native';
import { useTheme } from 'styled-components';

function Stat({ label, value }: { label: string; value: string }) {
  const theme = useTheme();
  const { rpx } = useResponsiveContext();
  return (
    <View style={{ minWidth: rpx(96), marginBottom: rpx(8) }}>
      <Typography.Text size={rpx(20)} bold color={theme.label.color}>
        {value}
      </Typography.Text>
      <Typography.Text size={rpx(12)} color={theme.label.color}>
        {label}
      </Typography.Text>
    </View>
  );
}

/** The headline numbers: what will be imported and who is due. */
export function SummaryStats({ summary }: { summary: ApdmImportSummary }) {
  const theme = useTheme();
  const { rpx } = useResponsiveContext();
  return (
    <View>
      <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: rpx(16) }}>
        <Stat label="来店记录" value={String(summary.visits)} />
        <Stat label="车辆" value={String(summary.vehicles)} />
        <Stat label="有保养到期日" value={String(summary.dues.vehicles)} />
        <Stat label="30 天内到期" value={String(summary.dues.within30Days)} />
        <Stat label="已过期" value={String(summary.dues.overdue)} />
      </View>
      {summary.dateRange ? (
        <Typography.Text size={rpx(13)} color={theme.label.color}>
          记录时间：{summary.dateRange.from} 至 {summary.dateRange.through}
        </Typography.Text>
      ) : null}
    </View>
  );
}
